import React, { lazy } from 'react';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';
import { registerNavigation } from '@/core/navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons';

import { actions as warehouseActions } from './Incoming/Incoming.redux';
import { reducers as warehouseReducers } from './Incoming/Incoming.redux';

import { actions as outgoingActions } from './Outgoing/Outgoing.redux';
import { reducers as outgoingReducers } from './Outgoing/Outgoing.redux';

import { actions as warehouseProdActions } from './Production/Production.redux';
import { reducers as warehouseProdReducers } from './Production/Production.redux';

import { actions as warehouseTransferActions } from './Transfers/Transfers.redux';
import { reducers as warehouseTransferReducers } from './Transfers/Transfers.redux';

// import { actions as demoActions } from './Demo/Demo.redux';
// import { reducers as demoReducers } from './Demo/Demo.redux';

const Incoming = lazy(() => import('./Incoming/Incoming'));
const Production = lazy(() => import('./Production/Production'));
const Outgoing = lazy(() => import('./Outgoing/Outgoing'));
const Transfers = lazy(() => import('./Transfers/Transfers'));
//const Demo = lazy(() => import('./Demo/Demo'));


// IMPORTANT  new redux stores must be added, and they cannot be combined under the same name
registerReduxStore('warehouse', warehouseReducers, warehouseActions);
registerReduxStore('warehouseOut', outgoingReducers, outgoingActions);
registerReduxStore('warehouseProd', warehouseProdReducers, warehouseProdActions);
registerReduxStore('warehouseTransfers', warehouseTransferReducers, warehouseTransferActions);

//registerReduxStore('demo', demoReducers, demoActions);

registerRoutes([
    {
        path: '/warehouse/receiving',
        exact: true,
        render: <Incoming />,
        title: 'Warehouse: Receiving',
        private: true,
        permissions: ['warehouse_receiving_read'],
    },
    {
        path: '/warehouse/production',
        exact: true,
        render: <Production />,
        title: 'Warehouse: Production',
        private: true,
        permissions: ['warehouse_production_read'],
    },
    {
        path: '/warehouse/shipping',
        exact: true,
        render: <Outgoing />,
        title: 'Warehouse: Shipping',
        private: true,
        permissions: ['warehouse_shipping_read'],
    },
    {
        path: '/warehouse/transfers',
        exact: true,
        render: <Transfers />,
        title: 'Warehouse: Transfers',
        private: true,
        permissions: ['warehouse_transfers_read'],
    },
    // {
    //     path: '/warehouse/demo',
    //     exact: true,
    //     render: <Demo />,
    //     title: 'Warehouse: Demo Utilities',
    //     private: true,
    //     //permissions: ['prod_permissions_read'],
    // }
]);

registerNavigation({
    title: 'Warehouse',
    single: false,
    top: true,
    home: true,
    icon: <FontAwesomeIcon icon={faBoxOpen} />,
    permissions: ['warehouse_nav'],
    children: [
        {
            title: 'Receiving',
            url: '/warehouse/receiving',
            permissions: ['warehouse_receiving_read'],
        },
        {
            title: 'Production',
            url: '/warehouse/production',
            permissions: ['warehouse_production_read'],
        },
        {
            title: 'Shipping',
            url: '/warehouse/shipping',
            permissions: ['warehouse_shipping_read'],
        },
        {
            title: 'Transfers',
            url: '/warehouse/transfers',
            permissions: ['warehouse_transfers_read'],
        },
        // {
        //     title: 'Demo',
        //     url: '/warehouse/demo',
        //     //permissions: ['prod_permissions_read', 'prod_permissions_write'], 
        // },

    ],
});

